import React from 'react';
import styled from 'styled-components';

import SimpleModalOrMobilePage from '#/components/basic/modal/SimpleModalOrMobilePage';

import disabledDepositWithdrawIcon from './icons/disabledDepositWithdraw.svg';
import disabledRewardsIcon from './icons/disabledRewards.svg';

const Content = styled.div`
  text-align: center;
  /* Limit to make sure text wraps nicely */
  max-width: 280px;
  margin: 0 auto;
  line-height: normal;
`;

const Description = styled.div`
  color: var(--gray4c);
  font-size: var(--medium);
  line-height: normal;
`;

type Action = 'depositWithdraw' | 'claimReward';

export default function DisabledActionModal({
  action,
  onClose,
}: {
  action: Action;
  onClose: () => void;
}) {
  const texts =
    action === 'depositWithdraw'
      ? {
          icon: disabledDepositWithdrawIcon,
          headerTitle: 'Deposits & Withdrawals',
          title: 'Initiate Deposits and Withdrawals via Desktop',
          desc: 'Return to desktop and connect your custody wallet to deposit and withdraw.',
        }
      : {
          icon: disabledRewardsIcon,
          headerTitle: 'Claiming Rewards',
          title: 'Claim your Rewards via Desktop',
          desc: 'Return to desktop and connect your custody wallet to claim your rewards.',
        };

  return (
    <SimpleModalOrMobilePage
      size="small"
      title={texts.headerTitle}
      onClose={onClose}
      verticalAlignOnMobile="centered"
    >
      <Content>
        <img src={texts.icon} />
        <h1>{texts.title}</h1>
        <Description>{texts.desc}</Description>
      </Content>
    </SimpleModalOrMobilePage>
  );
}
